
import { Prescription } from '../models/index';

const now = new Date();
const thirtyDaysFromNow = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString();
const yesterday = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString();

export const MOCK_PRESCRIPTIONS: Prescription[] = [
  {
    id: 'PRES-MOCK-001',
    customerId: 'CUST001', // John Doe
    storeId: 'mock-store-id-12345',
    createdById: 'cashier01',
    status: 'APPROVED',
    createdAt: yesterday,
    expiresAt: thirtyDaysFromNow,
    doctorName: 'Dr. Somchai (Mock)',
    approvedItems: {
      categoryId: 'CAT001',
      categoryName: 'Flower',
      dosagePerDay: 1,
      dosageUnit: 'GRAM',
      durationDays: 30,
      totalAmount: 30,
      usageInstructions: 'Use as needed for pain relief.',
      symptoms: 'Chronic Pain'
    }
  },
   {
    id: 'PRES-MOCK-002',
    customerId: 'CUST001', // John Doe
    storeId: 'mock-store-id-12345',
    createdById: 'cashier01',
    status: 'APPROVED',
    createdAt: yesterday,
    expiresAt: thirtyDaysFromNow,
    doctorName: 'Dr. Somchai (Mock)',
    approvedItems: {
      categoryId: 'CAT002',
      categoryName: 'Edibles',
      dosagePerDay: 1,
      dosageUnit: 'PIECE',
      durationDays: 10,
      totalAmount: 10,
      usageInstructions: 'Take one before bedtime for insomnia.',
      symptoms: 'Insomnia'
    }
  }
];
